export const ADMIN_V2_URL = "https://admin2.edutalk.edu.vn";
